import { Injectable } from '@angular/core';
import { AutocompleteRequest, AutocompleteSuggestion, ShTaskAutocompleteDataService } from '@stylehaven/components';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DigihavenTaskAutocompleteDataService extends ShTaskAutocompleteDataService {
    protected readonly ENDPOINT: string = `v2/tasks/autocomplete/`;

    requestAutocompleteSuggestions(request: AutocompleteRequest): Observable<AutocompleteSuggestion[]> {
        // Force index wide to false to prevent data from other organisations leaking
        return super.requestAutocompleteSuggestions({
            ...request,
            IndexWide: false
        });
    }
}
